import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from '@dbk/ui-react-utils';
import { Tab, Tabs } from '@dbk/ui-tabs';
import { Small } from '@dbk/ui-text';
import SortingHeader from '../../../../../../src/components/common/sorting-header';
import ReportStatement from '../report-statement';
import ReportRMStatement from '../report-rm-statement';
import ReportCustom from '../report-custom';
import { EDELIVERY, ReportTypes, CUSTOM_REPORT_TYPES, SELECTED_RANGE } from '../constants';
import { testIDProps } from '../../../../../../src/common/components/utils/with-automation-id-props';
import { EBANKINGWEBLUX, EBANKINGWEBUK, RM_REGION} from '../../../constants.js';
import envConfig from '../../../../../../db-env-build';
import { RM_REGION_UK } from '../../../../../../src/constants';

class ReportCategoryParent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: props.reports.selectedReportType === 0 ? 0 : props.reports.selectedReportType,
    };
  }

  /**
   * function: parentTabListener will be listener for tab event from ParentTabLayout
   */

  /**
   * function: detailsTabListener will be listener for tab event from DetailTabLayout
   */
  // detailsTabListener = (index) => {
  //   this.setState({ detailViewTab: index });
  // }

  render() {
    const { i18n: { messages } } = this.props;
    return (
      <View style={{ flex: 1 }}>
        {/* <div className="column" style={{padding:0}}> */}
        <div>
          <SortingHeader
            enabled={false}
            showBorder={false}
            messages={messages}
          />
          <ReportStatement />
        </div>
      </View>
    );

  }
}

ReportCategoryParent.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object,
  }),
  selectedTab: PropTypes.bool,
};

ReportCategoryParent.defaultProps = {
  i18n: {},
  selectedTab: 0
};

export default createContainer({
  $queries: {
    edelivery: {
      getUserPreferences: { $call: 'getUserPreferences' },
      showPrompt: true,
    },
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    getLastStatements: {
      $call: 'reports.getLastStatements',
    },
    getDocuments: {
      $call: 'reports.getDocuments',
    },
    setSelectedReportTab: {
      $call: 'reports.setSelectedReportTab'
    },
    reports: {
      selectedReportTab: true,
      lastMonthStatements: true,
      selectedReportType: true,
      custom: {
        setSelectedCustomReportType: {
          $set: 'selectedCustomReportType'
        }
      }
    },
    setSelectedCategoryId: {
      $call: 'reports.setSelectedCategoryId'
    },
    getStatementPdf: {
      $call: 'monthly.getPdf',
    },
    dailyPdf: {
      pdf: true,
      setEmpty: { $set: 'pdf' },
    },
    resetAdvicesDates: { $call: 'advices.resetDates' },
    resetReportsDates: { $call: 'reports.resetDates' },
    portfolio: {
      netIncome: {
        value: true,
      },
    },
    setReportDetailDateRange: {
      $call: 'reports.setReportDetailDateRange',
    },
  },
})(ReportCategoryParent);
